module.exports = __webpack_public_path__ + "2f9a8ccf9cc7a2fb48b693743ac73b7e.MP3";